import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { stateConfig } from './session-timeout-popup.config';

@Component({
  selector: 'app-session-timeout-popup',
  imports: [DialogModule, CommonModule],
  templateUrl: './session-timeout-popup.html',
  styleUrl: './session-timeout-popup.scss',
})
export class SessionTimeoutPopup {
  @Input() visibleSessionTimerPopup = false;
  @Output() visibleSessionTimerPopupChange = new EventEmitter<boolean>();
  closeTimeoutIcon = 'assets/images/close-timeout-icon.svg';

  @Input() popupState: 1 | 2 | 3 = 3;  // 🌟 NEW

  closePopup() {
    this.visibleSessionTimerPopup = false;
    this.visibleSessionTimerPopupChange.emit(false);
  }

  get current() {
    return stateConfig[this.popupState] ?? stateConfig[1];
  }

  get headerBg() {
    return this.current.headerBg;
  }

  get pillStyles() {
    return this.current.pill;
  }

  get headingText() {
    return this.current.heading;
  }

  get importantCard() {
    const card = { ...this.current.card };

    if (this.popupState === 3) {
      card.text = this.dynamicWindowCrossedText;
    }
    return card;
  }

  get dynamicWindowCrossedText() {
    return `This check-in will appear under tomorrow's cycle (${this.tomorrowDateLabel})`;
  }

  get mainHeaderIcon() {
    return this.current.mainIcon;
  }

  get pillMiniIcon() {
    return this.current.pill.miniIcon;
  }

  get importantIconState() {
    return this.current.card.icon;
  }

  get tomorrowDateLabel() {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1)
    const month = tomorrow.toLocaleString('en-US', { month: 'long' });
    const day = tomorrow.getDate();
    return `${month} ${day}`;
  }

}
